import { Splide } from "@splidejs/splide";
import { technologiesLogoSlider } from "./sliders";

export default class TechnologiesLogoSlider {
    private section: HTMLElement;
    private sliderWrapper: HTMLElement | null;
    private slider: Splide | null = null;

    constructor(section: HTMLElement) {
        this.section = section;
        this.sliderWrapper = this.section.querySelector("#technologies-logo-slider");

        this.init();
    }

    public init = async (): Promise<void> => {
        if (!this.sliderWrapper) return;

        this.slider = technologiesLogoSlider(this.sliderWrapper);
    };
}
